export const Config = {
  "api_host": "/api/v1/",
  "public_client": "flipkart",
  "roi_cpa_campaign_margin": 0,
  "fullDateTimeFormat": "dd-MM-yyyy HH:mm",
  "dateTimeFormat": "dd-MM-yyyy",
  "timeFormat": "HH:mm",
  "defaultCurrency": "INR",
  "currencySymbol": "₹",
  "search_debounce_delay": 750,
  "defaultLocale": "en-IN",
  "defaultTimezone": "Asia/Kolkata",
  "basename": "/",
  "strategy_supply_type": "FAN",
  "support_link": "mailto:dspsupport@flipkart.com?subject=Flipkart Ads DSP Support Query",
  "auth0": {
    "domain": "mediamath.auth0.com",
    "clientId": "TcUO7DhAcES84U04rByEZ3CHpxxsKeBd"
  },
  "defaultReportColumns": {
    "app-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "site-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_revenue",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "geo": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions",
      "country_name",
      "region_name",
      "city_name"
      ],
    "performance": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_revenue",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "new-to-brand": [
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_conversions",
      "total_conversions_revenue",
      "total_unique_converters",
      "total_spend",
      "total_ntb_conversions",
      "total_ntb_revenue",
      "total_ntb_converters",
      "incremental_roas",
      ],
  },
  "hideReportColumns": {
    "app-transparency": ["advertiser_id", "agency_id", "campaign_end_date", "campaign_end_date_tz", "campaign_initial_start_date", "campaign_start_date", "exchange_id", "organization_id", "strategy_id", "media_cost", "media_cost_cpa", "media_cost_cpc", "media_cost_cpcv", "media_cost_cpm", "media_cost_pc_cpa", "media_cost_pv_cpa", "post_click_conversions", "post_view_conversions", "total_ad_cost_pc_cpa", "total_ad_cost_pv_cpa", "total_spend_pc_cpa", "total_spend_pv_cpa"],
    "site-transparency": ["advertiser_id", "agency_id", "campaign_end_date", "campaign_initial_start_date", "campaign_initial_start_date_tz", "campaign_start_date", "campaign_timezone_code", "exchange_id", "organization_id", "media_cost", "media_cost_cpa", "media_cost_cpc", "media_cost_cpcv", "media_cost_cpm", "media_cost_pc_cpa", "media_cost_pv_cpa", "media_cost_roi", "post_click_aov", "post_click_media_cost_roi", "post_click_revenue", "post_click_total_ad_cost_roi", "post_click_total_spend_roi", "post_view_aov", "post_view_conversions", "post_view_conversions_raw", "post_view_media_cost_roi", "post_view_revenue", "post_view_revenue_raw", "post_view_total_ad_cost_roi", "post_view_total_spend_roi", "revenue_raw", "total_ad_cost_pc_cpa", "total_ad_cost_pv_cpa", "total_ad_cost_roi", "total_aov", "total_revenue", "total_spend_pc_cpa", "total_spend_pv_cpa", "total_spend_roi"],
    "geo": ["advertiser_id", "agency_id", "campaign_end_date", "campaign_initial_start_date", "campaign_start_date", "exchange_id", "organization_id", "media_cost", "media_cost_cpa", "media_cost_cpc", "media_cost_cpcv", "media_cost_cpm", "media_cost_pc_cpa", "media_cost_pv_cpa", "post_click_conversions", "post_view_conversions", "total_ad_cost_pc_cpa", "total_ad_cost_pv_cpa", "total_spend_pc_cpa", "total_spend_pv_cpa","region_id","attribution_group"],
    "performance": ["agency_id", "attribution_group", "campaign_end_date", "campaign_initial_start_date", "campaign_initial_start_date_tz", "campaign_start_date", "client_product_estimate", "io_number", "prisma_campaign_id", "3pa_conversions", "3pa_media_cost_cpa", "3pa_media_cost_cpa_usd", "3pa_media_cost_roi", "3pa_rr_per_1k_imps", "3pa_total_ad_cost_cpa", "3pa_total_ad_cost_cpa_usd", "3pa_total_ad_cost_roi", "3pa_total_aov", "3pa_total_aov_usd", "3pa_total_revenue", "3pa_total_revenue_usd", "3pa_total_spend_cpa", "3pa_total_spend_cpa_usd", "3pa_total_spend_roi", "adserving_cost_usd", "adverification_cost_usd", "audience_verification_cost_usd", "billed_spend_usd", "client_exchange_cost", "client_margin_share", "client_margin_share_usd", "contextual_cost_usd", "ctc", "dynamic_creative_cost", "dynamic_creative_cost_usd", "facebook_actions", "facebook_app_installs", "facebook_likes", "facebook_page_engagement", "facebook_post_comments", "facebook_post_engagement", "facebook_post_reactions", "facebook_post_shares", "managed_service_fee", "managed_service_fee_usd", "margin", "margin_usd", "measurability_rate", "measurable", "measurement_cost", "measurement_cost_usd", "media_cost_cpa", "media_cost_cpa_usd", "media_cost_cpc", "media_cost_cpc_usd", "media_cost_cpcv", "media_cost_cpcv_usd", "media_cost_cpm", "media_cost_cpm_usd", "media_cost_pc_cpa", "media_cost_pc_cpa_usd", "media_cost_pv_cpa", "media_cost_pv_cpa_usd", "media_cost_roi", "media_cost_usd", "media_cost_vcpm_usd", "mm_data_cost_usd", "mm_margin_share", "mm_margin_share_usd", "mm_total_fee", "mm_total_fee_usd", "optimization_fee", "optimization_fee_usd", "platform_access_fee", "platform_access_fee_usd", "pmp_no_opto_fee_usd", "pmp_opto_fee", "pmp_opto_fee_usd", "post_click_aov", "post_click_aov_usd", "post_click_revenue_usd", "post_click_total_ad_cost_roi", "post_click_total_spend_roi", "post_view_aov", "post_view_aov_usd", "post_view_revenue", "post_view_revenue_raw", "post_view_revenue_raw_usd", "post_view_revenue_usd", "post_view_total_ad_cost_roi", "post_view_total_spend_roi", "privacy_compliance_cost_usd", "revenue", "revenue_usd", "rr_per_1k_imps", "source_media_enablement_fee", "source_media_enablement_fee_usd", "source_platform_access_fee", "total_ad_cost_cpa_usd", "total_ad_cost_cpc_usd", "total_ad_cost_cpcv_usd", "total_ad_cost_cpm_usd", "total_ad_cost_pc_cpa_usd", "total_ad_cost_pv_cpa_usd", "total_ad_cost_roi", "total_ad_cost_usd", "total_ad_cost_vcpm_usd", "total_aov_usd", "total_revenue_usd", "total_spend_cpa_usd", "total_spend_cpc_usd", "total_spend_cpcv_usd", "total_spend_cpm_usd", "total_spend_pc_cpa_usd", "total_spend_pv_cpa_usd", "total_spend_usd", "udi_data_cost_usd", "viewability_cost_usd"],
    "new-to-brand": [],
  },
  "reportingRowsPerPage": 10
};
